module.exports = {"Device":"Get Clockings from {{deviceName}}","Device Data":"All Data:{{all}} - New Data:{{new}}"}